import React from 'react';
import { observer } from 'mobx-react-lite';

import { roundTimeStore } from '../../../store';

const CountDownTimer = observer(() => {
  const { time } = roundTimeStore;

  return time > 0 ? (
    <div className='monti-countdown-holder'>
      <div className='monti-countdown'>
        <p className='monti-countdown-timer'>{time}</p>
      </div>
    </div>
  ) : (
    <></>
  );
});

export default CountDownTimer;
